<div class="burger-menu" [class.active]="active" (click)="onBurgerClicked()">
   <div class="burger-container">
      <div class="burger-inner"></div>
   </div>
</div>
